import script from "./PedidoPaso3.vue?vue&type=script&setup=true&lang=js"
export * from "./PedidoPaso3.vue?vue&type=script&setup=true&lang=js"

import "./PedidoPaso3.vue?vue&type=style&index=0&id=5bcaa058&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bcaa058"]])

export default __exports__